import { render, staticRenderFns } from "./ProdutosCategoria.vue?vue&type=template&id=02d09188&scoped=true"
import script from "./ProdutosCategoria.vue?vue&type=script&lang=js"
export * from "./ProdutosCategoria.vue?vue&type=script&lang=js"
import style0 from "./ProdutosCategoria.vue?vue&type=style&index=0&id=02d09188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d09188",
  null
  
)

export default component.exports